// YouTube constants
export const YOUTUBE_IFRAME_HOSTNAME = 'www.youtube.com'
export const YOUTUBE_HOSTNAME = 'youtube.com'
export const YOUTUBE_SHORT_HOSTNAME = 'youtu.be'
export const YOUTUBE_PLATFORM = 'youtube' as const
export const YOUTUBE_EMBED_PATH = 'embed'
export const YOUTUBE_EMBED_VIDEO_ID_REGEX = new RegExp(`\\/${YOUTUBE_EMBED_PATH}\\/([^?/]+)`)

// Vimeo constants
export const VIMEO_IFRAME_HOSTNAME = 'player.vimeo.com'
export const VIMEO_HOSTNAME = 'vimeo.com'
export const VIMEO_PLATFORM = 'vimeo' as const
export const VIMEO_VIDEO_PATH = 'video'
export const VIMEO_VIDEO_ID_REGEX = new RegExp(`\\/${VIMEO_VIDEO_PATH}\\/([^?/]+)`)

// iframe constants
export const aspectVariants = {
  '16:9': 'aspect-video',
  '4:3': 'aspect-[4/3]',
  '1:1': 'aspect-square',
}

export const IFRAME_VIDEO_CLASSNAME = `w-full ${aspectVariants['16:9']}`
